import { Icon } from '../ui/Icon';
import type { HeroView } from '../../utils/inicioView';

/**
 * Rediseño · Bloque C — el hero del Inicio (P-021, P-030; B0-05): el saludo, y el negocio con la fecha.
 *
 * Lo que el diseño dibuja y aquí no:
 *   · La foto del negocio. No hay dónde guardarla (P-032, B1) y un marcador «FOTO» sería decorado.
 *   · El selector de tienda (la flecha junto al nombre). Es una fase funcional; el alcance real de
 *     las cifras se dice en «Así va tu negocio», con la etiqueta que entrega el servidor.
 *   · El dibujo del negocio (un cono). Es de un negocio concreto: va un icono de tienda, como en el menú.
 */
export function InicioHero({ view, businessName, planNote }: {
  view: HeroView;
  businessName: string;
  /** P-085: la condición comercial, discreta («Beta privada · sin costo», «Prueba gratis · quedan 9 días»). */
  planNote?: string | null;
}) {
  return (
    <header className="n3-inicio__hero">
      <div className="n3-inicio__hero-copy">
        <h1 className="n3-inicio__hero-title">{view.greeting} <span aria-hidden="true">👋</span></h1>
        <p className="n3-inicio__hero-lead">{view.lead}</p>
      </div>
      <p className="n3-inicio__hero-business">
        <span aria-hidden="true" className="n3-inicio__hero-business-icon"><Icon name="stores" size={20} /></span>
        <span className="n3-inicio__hero-business-text">
          <strong className="n3-inicio__hero-business-name">{businessName}</strong>
          <span className="n3-inicio__hero-business-date">{view.dateLabel}</span>
          {planNote && <span className="n3-inicio__hero-plan">{planNote}</span>}
        </span>
      </p>
    </header>
  );
}
